import React from 'react'
import { Logo } from '@next-nx/shared-ui/icons'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import styles from './LandingHeader.module.sass'
import { useTrans, useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import Link from 'next/link'


interface Props {
  onClick?: () => void
  className?: string
  variant?: 'modal' | 'in_pagina'
}

const LandingHeader = (props: Props) => {

  const {
    onClick = undefined,
    className = '',
    variant = 'modal',
  } = props

  const t = useTrans()
  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'richiesta_preventivo',
      action_tech: 'click',
      action_type: 'richiedi_preventivo',
      action_timestamp,
      action_effect: 'form_richiesta_preventivo_accesso',
    })
  }

  return (
    <div className={`${styles.landingHeader} ${className}`}>
      <WContainer>
        <div className={styles.content}>
          {(variant === 'in_pagina') ?
            <Link href="/">
              <a className={styles.logo} target='_blank'>
                <Logo />
              </a>
            </Link>
            :
            <Link href="/">
              <a className={styles.logo}>
                <Logo />
              </a>
            </Link>
          }
          {!!onClick && <Button label={t("Richiedi un preventivo")} labelMobile={t("Richiedi preventivo")} onClick={() => {
            onClick()
            handleTracking()
          }} responsive />}
        </div>
      </WContainer>
    </div>
  )
}

export default LandingHeader
